module.exports = __webpack_public_path__ + "img/leiterinnen_stefanie-amrein.75267df4.png";